// Keeps the open configuration panel's workflow in the URL, so an open panel can be
// linked, bookmarked and survives a reload.

import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';

const PARAM = 'workflow';

export function useWorkflowSelection() {
  const [searchParams, setSearchParams] = useSearchParams();
  const selectedCode = searchParams.get(PARAM);

  const selectWorkflow = useCallback(
    (shortCode: string) => {
      setSearchParams(
        (current) => {
          const next = new URLSearchParams(current);
          next.set(PARAM, shortCode);
          return next;
        },
        // replace: selecting rows should not fill the browser's back stack
        { replace: true }
      );
    },
    [setSearchParams]
  );

  const clearSelection = useCallback(() => {
    setSearchParams(
      (current) => {
        const next = new URLSearchParams(current);
        next.delete(PARAM);
        return next;
      },
      { replace: true }
    );
  }, [setSearchParams]);

  return { selectedCode, selectWorkflow, clearSelection };
}
